import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  subtitle: () => __(translations.commercialDocumentComponents.subtitle, 'Subtitle'),
};
